import "./Icon.html";
import "./Icon.scss";

import type { IControllerConstructor, Injectable } from "angular";

export class IconComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        // tslint:disable:object-literal-sort-keys
        this.bindings = {
            icon: "<?",
            response: "<?", // Preferred way. IResponseWithLoading<T> or IResponse<T>-like
            isLoading: "<?",
            hasError: "<?",
            extraClasses: "<?",
        };
        this.templateUrl = "/App/Modules/Gui/Components/Icon/Icon.html";
    }
}
